import { authRevokeJwtToken } from 'Services/auth.services';

const useRevokeJwt = () => {
  return authRevokeJwtToken();
}

export default useRevokeJwt;
